<script>
import MagComponent from './Mag.vue';
import LinksComponent from './Links.vue';

export default {
  components: {
    MagComponent,
    LinksComponent,
  },
  props: {
    value: Boolean,
    module: Object,
  },
  methods: {
    omni() {
      this.module.omni = !this.module.omni;
    },
  },
};
</script>
<template>
  <v-menu
    :value="value"
    @input="$emit('input', $event)"
    left
    bottom
    offset-y
    :close-on-click="false"
    max-height="80vh"
    min-width="300px"
    max-width="420px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-help-circle</v-icon>
      </v-btn>
    </template>
    <MagComponent
      v-if="module.hideLinksMag"
    />
    <LinksComponent
      :items="module.items"
    />
  </v-menu>
</template>
<style lang="scss">
</style>
